import { Check, Play } from "lucide-react";
import { isProblemType } from "@iamu/shared";
import { Button } from "@/components/ui/button";
import { SimpleTooltip } from "@/components/ui/tooltip";
import { ActionBar } from "@/components/layout/action-bar";
import {
  FindingFixDropdown,
  FindingTriageMenu,
} from "@/components/experience/finding-actions";
import type { FindingType, CanonicalState } from "@/components/finding-badges";

interface FindingDetailActionsProps {
  isCanonical: boolean;
  type: FindingType;
  openRequest: any;
  state: CanonicalState;
  findingId: string;
  projectId: string;
  hasLinkedRepo: boolean;
  requests: any;
  transition: any;
  title: string;
}

export function FindingDetailActions({
  isCanonical,
  type,
  openRequest,
  state,
  findingId,
  projectId,
  hasLinkedRepo,
  requests,
  transition,
  title,
}: FindingDetailActionsProps) {
  const primary =
    isCanonical && isProblemType(type) ? (
      openRequest ? (
        <Button
          onClick={() => requests.cancel(openRequest.id)}
          disabled={requests.isPending}
        >
          Cancel request
        </Button>
      ) : state === "new" ? (
        <Button
          onClick={() =>
            transition.run(
              { ids: [findingId], to: "open" },
              "Accepted — moved to Ready to fix",
            )
          }
          disabled={transition.isPending}
        >
          <Check className="mr-2 h-4 w-4" />
          Accept
        </Button>
      ) : state === "fix_applied" ? (
        <SimpleTooltip content="A teammate's agent re-runs the scenario on next sync">
          <Button
            onClick={() =>
              requests.queue({
                kind: "verify",
                canonicalId: findingId,
              })
            }
            disabled={requests.isPending}
          >
            <Play className="mr-2 h-4 w-4" />
            Queue verify
          </Button>
        </SimpleTooltip>
      ) : (
        <FindingFixDropdown
          findingId={findingId}
          projectId={projectId}
          hasLinkedRepo={hasLinkedRepo}
          state={state}
          requests={requests}
          open={openRequest}
        />
      )
    ) : undefined;

  const secondary = [
    ...(isCanonical && isProblemType(type) && state === "new" && !openRequest
      ? [
          <FindingFixDropdown
            key="fix"
            findingId={findingId}
            projectId={projectId}
            hasLinkedRepo={hasLinkedRepo}
            state={state}
            requests={requests}
            open={openRequest}
          />,
        ]
      : []),
    <FindingTriageMenu
      key="triage"
      findingId={findingId}
      projectId={projectId}
      state={state}
      findingType={type}
      subject={title}
    />,
  ];

  return <ActionBar primary={primary} secondary={secondary} />;
}
